import { MatchMedia } from '@helvetia/components/MatchMedia'
import Spinner from '@helvetia/components/Spinner/Spinner'
import Text from '@helvetia/components/Text'
import * as React from 'react'
import { withNamespaces, WithNamespaces } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router'

import { eventEmitter } from '../core'
import {
  authUser,
  Events,
  isAuthenticated,
} from '../core/services/auth.service'
import { Modal } from './_components/Modal'

interface Props {}
interface State {
  isLoading: boolean
}

class InitialLoading extends React.Component<
  Props & RouteComponentProps & WithNamespaces,
  State
> {
  state = {
    isLoading: true,
  }

  removeAuthenticatedUserEvent: Function

  async componentDidMount() {
    this.removeAuthenticatedUserEvent = eventEmitter.on(
      Events.AUTHENTICATED_USER,
      this.setLoadingToFalse,
    )
    await authUser()
    this.setLoadingToFalse()
  }

  setLoadingToFalse = () => {
    this.setState({ isLoading: false })
  }

  componentWillUnmount() {
    this.removeAuthenticatedUserEvent()
  }

  showSessionExpiredModal = t => {
    return (
      <Modal
        buttonText={t('buttons.accept')}
        onClose={() => this.props.history.push('/calculator/vehicles')}
        title={
          <>
            <MatchMedia onlyMobile>
              <Text size="sBold">{t('modal.sessionExpired.title')}</Text>
            </MatchMedia>
            <MatchMedia tablet>
              <Text size="sBold">{t('modal.sessionExpired.title')}</Text>
            </MatchMedia>
          </>
        }
      >
        <Text size="s" as="p" color="black">
          {t('modal.sessionExpired.p1')}
        </Text>
      </Modal>
    )
  }

  render() {
    const path = this.props.location.pathname

    if (this.state.isLoading) return <Spinner size="xl" />

    if (
      !isAuthenticated() &&
      !path.includes('/login') &&
      !path.includes('/vehicles') &&
      !path.includes('/home')
    )
      return this.showSessionExpiredModal(this.props.t)

    return this.props.children
  }
}

export default withNamespaces()(withRouter(InitialLoading))
